
import Vue from "vue";
import { SaleSettings } from "@/models/user-configs/sale-settings";
import { TranslateResult } from "vue-i18n";
import { SaleEditRowExtraInfoField } from "@/utils/sale-edit/sale-edit-row-extra-info-field";
import AppSaleEditRowExtraInfoFieldSettingsEdit from "./SaleEditRowExtraInfoFieldsSettingsEdit.vue";
import { Model, getModel } from "@/utils/models/model";

export default Vue.extend({
	data(){
		return {
			toEditRow: null as null | SaleEditRowExtraInfoField
		};
	},
	props: {
		settings: {
			type: Object as ()=>SaleSettings,
			required: true
		}
	},
	computed: {
		title():TranslateResult {
			return this.$ct("sale-edit-row-extra-info-fields-settings");
		},
		items():SaleEditRowExtraInfoField[]{
			return this.settings.SaleEditRowExtraInfoFields;
		},
		model():Model{
			return getModel("Product");
		},
		editRowIsNewRow():boolean {
			if (!this.toEditRow) return true;
			return this.settings.SaleEditRowExtraInfoFields.indexOf(this.toEditRow) == -1;
		}
	},
	methods: {
		addItem(){
			this.toEditRow = new SaleEditRowExtraInfoField();
		},
		editItem(item:SaleEditRowExtraInfoField){
			this.toEditRow = item;
		},
		onEditRowSave(value:SaleEditRowExtraInfoField){
			if (!this.toEditRow) return;
			let index = this.settings.SaleEditRowExtraInfoFields.indexOf(this.toEditRow);
			if (index == -1) {
				this.settings.SaleEditRowExtraInfoFields.push(value);
			}else{
				this.$set(this.settings.SaleEditRowExtraInfoFields, index, value);
				this.toEditRow = value;
			}
		},
		removeItem(i:number){
			this.settings.SaleEditRowExtraInfoFields.splice(i, 1);
		}
	},
	components: {
		AppSaleEditRowExtraInfoFieldSettingsEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
